import StepIcon from "./icons/StepIcon";
import styles from "./style.module.scss";

const Steps = ({ current = 0, items }: { current: number; items: any }) => {
  return (
    <div className={styles.stepContainer}>
      {items.map((step: any) => {
        return (
          <div key={step.key} className={styles.stepItems}>
            <div
              className={`${styles.step} ${
                step.key <= current ? styles.active : ""
              }`}
            >
              {step.key}
            </div>
            <div
              className={`${styles.stepTxt} ${
                step.key <= current ? styles.Txtactive : ""
              }`}
            >
              {step.title}
            </div>
            {step.key === 3 ? "" : <StepIcon />}
          </div>
        );
      })}
    </div>
  );
};

export default Steps;
